/**
 * Adapts the V2 participant-rating response to the legacy summary shape used
 * by the payment/register UI. The API contract remains V2; this boundary keeps
 * legacy UI bindings stable while workflows are migrated incrementally.
 */
export function normalizeParticipantRatingForIntake(response: any): any {
    const source = response && (response.summary || response);
    if (!source) { return null; }

    return {
        ...source,
        participantRatingId: source.participantRatingId ?? source.id ?? null,
        participant: source.participant ?? source.participantEnrollment?.participant ?? null,
        referralResponse: source.referralResponse ?? {
            isReferral: source.isReferral ?? false
        },
        itemSummaries: source.itemSummaries ?? [],
        allowPremiumFinance: source.allowPremiumFinance ?? false,
        premium: source.premium ?? 0,
        adjustedPremium: source.adjustedPremium ?? source.premium ?? 0,
        total: source.total ?? 0,
        agencyFee: source.agencyFee ?? 0,
        adjustedTaxes: source.adjustedTaxes ?? source.taxes ?? 0,
        adjustedFees: source.adjustedFees ?? source.fees ?? 0,
        surcharge: source.surcharge ?? 0,
        surchargeType: source.surchargeType ?? 0
    };
}
